import React, { useState } from 'react';
import NavItem from './NavItem';
import { ReactComponent as IconExperimentInfo } from '../../Icons/Exp_Sidebar/ExperimentInfo.svg';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { RMHelpURL, RMLiteHelpURL } from 'utils/Global';
import NotificationsPanel from './NotificationsPanel';
import useRMLite from 'CustomHooks/useRMLite';

const ScreenSidebar = ({ to }: any) => {
  const DESIGN = 'DESIGN';
  const HELPANDSUPPORT = 'HELPANDSUPPORT';
  const REPORT = 'REPORT';
  const [openedNavItem, setOpenedNavItem] = useState({ value: DESIGN });
  const rmLite = useRMLite();

  const onNavItemClick = (navItemId) => {
    if (openedNavItem.value === navItemId) {
      setOpenedNavItem({ value: null });
    } else {
      setOpenedNavItem({ value: navItemId });
    }
    if (navItemId === 'HELPANDSUPPORT') {
      window.open(rmLite ? RMLiteHelpURL : RMHelpURL, 'webhelp');
    }
  };

  return (
    <div id='screensidebar-container' className="sidebar border-sidebar h-100">
      <NotificationsPanel key={'user'} />
      <NavItem
        to={`/screen/${to}/info`}
        label="Info"
        key="experiment_info"
        icon={<IconExperimentInfo id='screensidebar-iconexperimentinfo' />}
        onClick={() => onNavItemClick(DESIGN)}
      />
      <NavItem
        to={`/screen/${to}`}
        label="Canvas"
        key="canvas"
        icon={<RMSvgIcon id='screensidebar-canvas' name="Canvas" fill={'#FFFFFF'} />}
        onClick={() => onNavItemClick(REPORT)}
      />
      <NavItem
        to={`/screen/${to}/?help`}
        label="Help"
        key="help"
        icon={<RMSvgIcon id='screensidebar-help' name="Help" fill={'#ffffff'} />}
        onClick={() => onNavItemClick(HELPANDSUPPORT)}
      />
    </div>
  );
};

export default ScreenSidebar;
